import React, { useCallback, useEffect } from 'react';
import { IKlarityProgram } from 'types/programs';
import { getKlarityProgamesList } from 'api/operation/programs';

const useGetProgramsList = ():[IKlarityProgram[]|undefined, boolean, ()=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<IKlarityProgram[]>([]);
    const fetchData = useCallback(async () => {
        if (loading) return;
        try {
            setLoading(true);
            const result = await getKlarityProgamesList();
            if (!result.error) {
                const resData = result?.data?.data || [];

                setItems(resData);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, [loading]);

    useEffect(() => {
        fetchData();
    }, []);

    return [items, loading, fetchData];
};

export default useGetProgramsList;
